import React from 'react'
import { Formik } from 'formik'
import { Button } from '@material-ui/core'
import { useStyles } from './SeatsDistribution.style'
import SeatSettings from './SeatSettings/SeatSettings'

export const SeatsDistribution = ({ values, onCancel }) => {
  const classes = useStyles()

  return (
    <Formik
      enableReinitialize
      initialValues={values}
      validateOnChange={false}
      validateOnBlur={false}>
      {() => (
        <div className={classes.formContainer}>
          <SeatSettings />
          <div className={classes.actionsContainer}>
            <Button onClick={onCancel} color='primary'>
              Volver
            </Button>
          </div>
        </div>
      )}
    </Formik>
  )
}

export default SeatsDistribution
